import { FormModeConfig, FormModeDefaults } from '../../../base/interfaces/formModes'
import { TransferenciaRecepcionInputProps } from '../interfaces'

export type TransferenciaRecepcionFormMode = 'create' | 'consult'

export const transferenciaRecepcionFormModeDefault: FormModeDefaults<TransferenciaRecepcionFormMode> = {
  create: {
    disabled: false,
  },
  consult: {
    disabled: true,
  },
}

export const transferenciaRecepcionFormModeConfig: FormModeConfig<
  TransferenciaRecepcionInputProps,
  TransferenciaRecepcionFormMode
> = {
  comentario: {
    create: { disabled: false },
    consult: { disabled: true },
  },

  detalle: {
    create: { disabled: false },
    consult: { disabled: true },
  },

  detalleOriginal: {
    create: { disabled: true },
    consult: { disabled: true },
  },

  recepcion: {
    create: { disabled: true },
    consult: { disabled: true },
  },
}
